import User1 from "../../assets/images/user/user (1).jpg";
import User2 from "../../assets/images/user/user (2).png";
import User3 from "../../assets/images/user/user (3).png";
import User4 from "../../assets/images/user/user (4).png";
import User5 from "../../assets/images/user/user (5).png";
import User6 from "../../assets/images/user/user (6).png";
import User7 from "../../assets/images/user/user (7).png";
import User8 from "../../assets/images/user/user (8).png";


const Users = [
  {
    _id: "1",
    Name: "John Doe",
    phone: "0712345001",
    address: "Kurumankadu, Vavuniya",
    image: User1,
  },
  {
    _id: "2",
    Name: "Jane Smith",
    phone: "0712345002",
    address: "Veppankulam, Vavuniya",
    image: User2,
  },
  {
    _id: "3",
    Name: "Michael Brown",
    phone: "0712345003",
    address: "Paddanichoor, Vavuniya",
    image: User3,
  },
  {
    _id: "4",
    Name: "Emily Davis",
    phone: "0712345004",
    address: "Kurumankadu, Vavuniya",
    image: User4,
  },
  {
    _id: "5",
    Name: "David Wilson",
    phone: "0712345005",
    address: "Veppankulam, Vavuniya",
    image: User5,
  },
  {
    _id: "6",
    Name: "Sarah Johnson",
    phone: "0712345006",
    address: "Paddanichoor, Vavuniya",
    image: User6,
  },
  {
    _id: "7",
    Name: "James Lee",
    phone: "0712345007",
    address: "Kurumankadu, Vavuniya",
    image: User7,
  },
  {
    _id: "8",
    Name: "Patricia Kim",
    phone: "0712345008",
    address: "Veppankulam, Vavuniya",
    image: User8,
  },

];

export default Users;
